import React from 'react';
import { styled } from '@mui/material';
import { AvailChip } from '@/components/_common/Table/Calendar/CalendarComponents/common';
import { titleCase } from '@/_utils/utils';

interface Props {
  label: string;
}

const VersionNameChip: React.FC<Props> = ({ label }) => {
  return <StyledAvailChip label={titleCase(label)} variant="outlined" color="primary" />;
};

export default VersionNameChip;

const StyledAvailChip = styled(AvailChip)`
  color: #18ad9d;
  border-color: #18ad9d;
`;
